import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const WhatsAppAIBotsPage: React.FC = () => {
    return (
        <Fragment>
            <Helmet>
                <title>WhatsApp AI Bots | AquarLabs</title>
                <meta name="description" content="Engage customers 24/7 with AquarLabs' WhatsApp AI Bots. Automate customer support, sales, and marketing with intelligent conversational AI on the world's most popular messaging platform." />
                <meta name="keywords" content="WhatsApp bot, WhatsApp automation, chatbot, conversational AI, WhatsApp Business API, customer support automation, AquarLabs" />
            </Helmet>
            <div className="about-page inner-page">
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="WhatsApp AI Bots" pagesub="WhatsApp AI Bots" parentPage="Solutions" parentLink="/service" />

                        {/* Hero Section */}
                        <section className="service-hero-section" style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.8) 100%)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h1 style={{ fontSize: "3rem", marginBottom: "20px", color: "#fff" }}>WhatsApp AI Bots</h1>
                                        <p style={{ fontSize: "1.25rem", color: "rgba(255,255,255,0.8)", lineHeight: "1.8" }}>
                                            Transform customer engagement with intelligent WhatsApp automation. Our AI-powered bots handle sales, support, and marketing conversations 24/7, delivering instant responses on the platform your customers love.
                                        </p>
                                        <Link to="/contact-us" className="thm-btn agency-btn" style={{ marginTop: "30px", display: "inline-block" }}>
                                            <span className="text">Get Started</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Overview Section */}
                        <section style={{ padding: "80px 0" }}>
                            <div className="container">
                                <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Overview</span>
                                <h2 style={{ fontSize: "2.5rem", margin: "15px 0 30px", color: "#fff" }}>Conversational AI for WhatsApp Business</h2>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)" }}>
                                    AquarLabs' WhatsApp AI Bots leverage the official WhatsApp Business API to create intelligent, branded conversational experiences. Our bots understand natural language, handle complex multi-turn conversations, and seamlessly hand off to human agents when needed.
                                </p>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)", marginTop: "20px" }}>
                                    From answering FAQs to processing orders, scheduling appointments, and sending personalized marketing messages, our WhatsApp solutions help you scale customer interactions while reducing operational costs.
                                </p>
                            </div>
                        </section>

                        {/* Services Section */}
                        <section style={{ padding: "80px 0", background: "rgba(0,2,15,0.3)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase" }}>Our Capabilities</span>
                                        <h2 style={{ fontSize: "2rem", margin: "15px 0", color: "#fff" }}>Complete WhatsApp Solutions</h2>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="row">
                                            {[
                                                {
                                                    title: "Customer Support",
                                                    desc: "Instant, intelligent responses to customer inquiries.",
                                                    items: ["FAQ Automation", "Ticket Creation & Tracking", "Seamless Agent Handoff"]
                                                },
                                                {
                                                    title: "Sales & Commerce",
                                                    desc: "Drive revenue through conversational commerce.",
                                                    items: ["Product Catalogs", "Order Processing", "Payment Integration"]
                                                },
                                                {
                                                    title: "Marketing & Engagement",
                                                    desc: "Personalized campaigns that drive results.",
                                                    items: ["Broadcast Messaging", "Personalized Offers", "Re-engagement Campaigns"]
                                                },
                                                {
                                                    title: "Appointment & Booking",
                                                    desc: "Streamline scheduling and reservations.",
                                                    items: ["Calendar Integration", "Automated Reminders", "Rescheduling & Cancellation"]
                                                }
                                            ].map((activity, index) => (
                                                <div key={index} className="col-md-6" style={{ marginBottom: "30px" }}>
                                                    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", padding: "30px", height: "100%" }}>
                                                        <h3 style={{ fontSize: "1.25rem", color: "#fff", marginBottom: "15px" }}>
                                                            <span style={{ color: "#fc9038" }}>●</span> {activity.title}
                                                        </h3>
                                                        <p style={{ fontSize: "0.95rem", color: "rgba(255,255,255,0.7)", marginBottom: "15px" }}>{activity.desc}</p>
                                                        <ul style={{ listStyle: "none", padding: 0 }}>
                                                            {activity.items.map((item, i) => (
                                                                <li key={i} style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", padding: "5px 0" }}>→ {item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Why Us Section */}
                        <section style={{ padding: "80px 0", background: "#0a0a0a" }}>
                            <div className="container">
                                <div className="text-center" style={{ marginBottom: "50px" }}>
                                    <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Why Us</span>
                                    <h2 style={{ fontSize: "2.5rem", margin: "15px 0 20px", color: "#fff" }}>Why Choose AquarLabs for WhatsApp AI?</h2>
                                    <p style={{ fontSize: "1rem", color: "rgba(255,255,255,0.6)", maxWidth: "700px", margin: "0 auto" }}>
                                        We build bots that feel human and deliver measurable business results.
                                    </p>
                                </div>
                                <div className="row">
                                    {[
                                        { title: "Official API Partner", desc: "Certified integration with WhatsApp Business API for reliability." },
                                        { title: "Advanced NLP", desc: "Natural language understanding that handles complex conversations." },
                                        { title: "Multi-language Support", desc: "Engage customers in their preferred language automatically." },
                                        { title: "Rich Media Support", desc: "Send images, videos, documents, and interactive buttons." },
                                        { title: "Analytics Dashboard", desc: "Track performance, conversation metrics, and customer insights." },
                                        { title: "CRM Integration", desc: "Sync conversations with Salesforce, HubSpot, and other CRMs." }
                                    ].map((item, index) => (
                                        <div key={index} className="col-lg-6" style={{ marginBottom: "20px" }}>
                                            <div style={{
                                                background: "rgba(20, 20, 20, 0.8)",
                                                border: "1px solid rgba(252, 144, 56, 0.4)",
                                                borderRadius: "16px",
                                                padding: "28px 30px",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: "15px"
                                            }}>
                                                <div style={{
                                                    minWidth: "40px",
                                                    height: "40px",
                                                    borderRadius: "8px",
                                                    background: "rgba(252, 144, 56, 0.1)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21 11.5C21 16.75 16.75 21 11.5 21C9.93 21 8.44 20.63 7.12 19.97L3 21L4.03 16.88C3.37 15.56 3 14.07 3 12.5C3 7.25 7.25 3 12.5 3C17.75 3 22 7.25 22 12.5" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M8 10H8.01" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" />
                                                        <path d="M12 10H12.01" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" />
                                                        <path d="M16 10H16.01" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <h3 style={{ fontSize: "1.1rem", color: "#fff", marginBottom: "8px", fontWeight: "600" }}>{item.title}</h3>
                                                    <p style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", margin: 0, lineHeight: "1.6" }}>{item.desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>

                        {/* CTA Section */}
                        <section style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.5) 100%)" }}>
                            <div className="container text-center">
                                <h2 style={{ fontSize: "2.5rem", color: "#fff", marginBottom: "20px" }}>Launch Your WhatsApp Bot</h2>
                                <p style={{ fontSize: "1.2rem", color: "rgba(255,255,255,0.7)", marginBottom: "30px" }}>
                                    Start automating customer conversations on WhatsApp today.
                                </p>
                                <Link to="/contact-us" className="thm-btn agency-btn">
                                    <span className="text">Contact Us Today</span>
                                </Link>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default WhatsAppAIBotsPage;
